<template>
  <div class="content">
    <!-- 券 -->
    <van-dialog class="ticketDialog" v-model="ticketVisible" :showConfirmButton="false">
      <div class="ticket">
        <h2>{{ money }}</h2>
        <img class="ticket_btn" src="@/assets/img/ticket_btn.png" alt="" @click="ticketClose" />
        <img class="ticket_close" src="@/assets/img/ticket_close.png" alt="" @click="ticketClose" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast } from 'vant'
import { scoreFuncNameList } from '@/utils/contacts_score_config'

Vue.use(Toast)
export default {
  props: {
    money: {
      default: 'Rp0'
    }
  },
  data () {
    return {
      ticketVisible: false
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  created () {
    // 券
    if (!localStorage.getItem('showTicket')) {
      this.ticketVisible = true
    }
  },
  methods: {
    // 券弹窗关闭
    ticketClose () {
      Toast('Berhasil ambil, gunakan pada pinjaman berikutnya')
      localStorage.setItem('showTicket', true)
      setTimeout(() => {
        this.ticketVisible = false
        try {
          const scoreList = scoreFuncNameList
          // 使用 some 方法遍历数组，当遇到第一个有效的方法时调用它并停止遍历
          scoreList.some(handler => {
            if (window.webkit?.messageHandlers[handler]) {
              window.webkit.messageHandlers[handler].postMessage('')
              return true // 返回 true 以停止遍历
            }
            return false // 继续遍历
          })
        } catch (e) {
          console.log(e)
        }
      }, 700)
      if (!localStorage.getItem('showEvaluate')) {
        this.commentVisible = true
      }
    }
  }
}
</script>

<style scoped lang='less'>
.commentDialog {
  .rise-limit-title {
    .dialog-title;
    padding-left: 24px;
    text-align: left;
    background: none;
    color: #000;
    font-size: 30px;
    font-weight: 600;
  }

  .tip {
    padding-left: 49px;
    padding-right: 49px;
    margin-top: 16px;
    font-size: 26px;
    color: #000;
    text-align: center;
  }

  .toStore-btn {
    .submit-btn;
    width: 500px;
    height: 88px;
    line-height: 88px;
    border-radius: 8px;
    margin: 80px auto 84px;
    font-size: 30px;
    color: #fff;
  }

  .hiddenIcon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.ticketDialog {
  background: none;

  .ticket {
    background: none;
    position: relative;
    height: 900px;
    background: url("~@/assets/img/ticket_bg.png") no-repeat;
    background-size: contain;
    z-index: 9;

    h2 {
      text-align: center;
      padding-top: 335px;
      color: #fb0003;
      font-size: 32px;
    }

    img {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .ticket_btn {
      bottom: 155px;
      width: 300px;
    }

    .ticket_close {
      bottom: 0;
      width: 100px;
    }
  }
}
</style>
